import React, { PureComponent } from "react";
import { Link } from "react-router-dom";
import { formatDate, formatDateTime } from "../../lib/formats";
import styled from "styled-components";
import { PATH_FOLDER_LIST, getLink } from "../../routes";

import FolderIcon from "react-icons/lib/md/folder";
import RemoveIcon from "react-icons/lib/md/delete";
import EditIcon from "react-icons/lib/md/create";

export const FolderLinkCell = ({ rowData }) => {
  const { name, id, type } = rowData;
  return (
    <Link to={getLink(PATH_FOLDER_LIST, { folderId: id, type })}>
      <span>
        <FolderIcon size={24} />
      </span>
      {name}
    </Link>
  );
};

export const DateCell = ({ rowData, dataKey }) => {
  return formatDate(rowData[dataKey]);
};

export const DateTimeCell = ({ rowData, dataKey }) => {
  return formatDateTime(rowData[dataKey]);
};

const StyledControlsCell = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  svg {
    margin: 0 5px;
    cursor: pointer;
  }
`;

export class ControlsCell extends PureComponent {
  onEdit = () => {
    const { rowData, onEdit } = this.props;
    onEdit({ rowData });
  };
  onRemove = () => {
    const { rowData, onRemove } = this.props;
    onRemove({ rowData });
  };
  render() {
    return (
      <StyledControlsCell className="controls-cell">
        <EditIcon size={24} onClick={this.onEdit} />
        {this.props.onRemove ? (
          <RemoveIcon size={24} onClick={this.onRemove} />
        ) : null}
      </StyledControlsCell>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ui/dataCells.js